import type React from "react";

export function CartIcon(
  props: React.SVGProps<SVGSVGElement>,
): React.ReactNode {
  return (
    <svg
      viewBox="0 0 24 24"
      width="24"
      height="24"
      fill="currentColor"
      {...props}
    >
      <title>Shopping Cart Outlined</title>
      <path d="M7 22a2 2 0 1 1 0-4 2 2 0 0 1 0 4m10 0a2 2 0 1 1 0-4 2 2 0 0 1 0 4M6.15 6l2.4 5h7l2.75-5zM5.2 4h14.75c.383 0 .675.171.875.513s.208.687.025 1.037l-3.55 6.4a2.06 2.06 0 0 1-.737.775c-.309.183-.647.275-1.013.275H8.1L7 15h12v2H7c-.75 0-1.317-.329-1.7-.988-.383-.658-.4-1.312-.05-1.962L6.6 11.6 3 4H1V2h3.25z" />
    </svg>
  );
}
